import React, {useEffect} from 'react';
import Header from '../presentations/Header';
import FullScreenContainer from '../presentations/FullScreenContainer';
import ForgotPasswordFormSended from '../presentations/ForgotPasswordFormSended';
import {useTranslation} from 'react-i18next';
import { appEnv } from '../config/env';

const ForgotPasswordSended = () => {
  const {t} = useTranslation();

  useEffect(() => {
    document.title = `${appEnv.name} - ${t('Forgot your password')}`;
  }, []);

  return (
          <>
            <Header/>

            <FullScreenContainer centering={true}>
              <main>
                <ForgotPasswordFormSended/>
              </main>
            </FullScreenContainer>
          </>
  );
};

export default ForgotPasswordSended;
